import React from 'react'
import classNames from 'classnames'

export default function CarOverviewColorInput ({ id, value, updateColorValue, minimumValue }) {
  if (typeof value !== 'number' || !id) {
    return null
  }

  const handleDecrement = () => {
    if (value === minimumValue || value === 0) {
      return
    }

    const newVal = value - 1
    handleChange(newVal)
  }

  const handleIncrement = () => {
    const newVal = value + 1
    handleChange(newVal)
  }

  const handleChange = (v) => {
    updateColorValue(id, v)
  }

  return (
    <div className='car-overview__color-input'>
      <button
        className={classNames('car-overview__color-input-button car-overview__color-input-button--decrement', {
          'car-overview__color-input-button--disabled': value === minimumValue || value === 0
        })}
        onClick={handleDecrement}
      />
      <div className='car-overview__color-input-value'>{value}</div>
      <button
        className='car-overview__color-input-button car-overview__color-input-button--increment'
        onClick={handleIncrement}
      />
    </div>
  )
}
